import React from 'react';
import ApplicationCard from "../../ApplicationCard/ApplicationCard";
import {PktIcon} from "@oslokommune/punkt-react";
import {Barnehageplass} from "../../../api/barnehageplassStatus";

type PlassertCardProps = {
    barnNavn: string;
    barnehageplasser: Array<Barnehageplass>;
}

const PlassertCard = ({barnNavn, barnehageplasser}: PlassertCardProps) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // aktiveBarnehageplasser er plasser som ikke har sluttdato, eller som har sluttDato i fremtiden
    const aktiveBarnehageplasser = barnehageplasser.filter(barnehageplass => {
        const endDate = barnehageplass.sluttDato
            ? new Date(`${barnehageplass.sluttDato}T00:00:00`) // Lokal tid, samme som today
            : null;
        return !endDate || endDate >= today;
    });

    if (aktiveBarnehageplasser.length === 0) {
        return null;
    }

    const sortedBarnehageplasser = aktiveBarnehageplasser.sort((a, b) =>
        new Date(`${a.startDato}T00:00:00`).getTime() - new Date(`${b.startDato}T00:00:00`).getTime()
    );

    const [nåværendePlass, ...fremtidigePlasser] = sortedBarnehageplasser;

    return (
        <ApplicationCard title={barnNavn} variant={"grå"}>
            {fremtidigePlasser.length > 0 && (
                <h4 className="pkt-txt-16" style={{marginTop: '16px'}}>
                    Nåværende barnehage
                </h4>
            )}
            <Barnehageplassinfo barnehageplass={nåværendePlass}/>

            {fremtidigePlasser.map((fremtidigPlass) => (
                <div key={fremtidigPlass.startDato}>
                    <h4 className="pkt-txt-16" style={{marginTop: '16px'}}>
                        Ny barnehage
                    </h4>
                    <Barnehageplassinfo barnehageplass={fremtidigPlass}/>
                </div>
            ))}
        </ApplicationCard>
    );
};

function Barnehageplassinfo({barnehageplass}: { barnehageplass: Barnehageplass }) {
    const startDato = new Date(barnehageplass.startDato).toLocaleString('no', {dateStyle: "long"});
    const sluttDato = barnehageplass.sluttDato
        ? new Date(barnehageplass.sluttDato).toLocaleString('no', {dateStyle: "long"})
        : null;

    return (
        <>
            <div className={"pkt-txt-16-medium barnehageName"} style={{display: 'flex', alignItems: 'center'}}>
                <PktIcon className={'pkt-icon--medium mr-size-12'} name={'playground'}/>
                {barnehageplass.barnehageNavn}
            </div>
            <div className={"pkt-txt-16-light"} style={{display: 'flex', alignItems: 'center'}}>
                <PktIcon className={'pkt-icon--medium mr-size-12'} name={'calendar'}/>
                Har plass fra {startDato}
                {sluttDato && ` til ${sluttDato}`}
            </div>
        </>
    );
}


export default PlassertCard;